const Dashboard = () => import('Modules/dashboard/views/Index')
const Agenda = () => import('Modules/dashboard/views/Agenda')
const AtencionPaciente = () => import('Modules/dashboard/views/AtencionPaciente')

const rutas = [{
  name: 'dashboard',
  component: Dashboard,
  path: 'dashboard',
  meta: {
    requiresAuth: true,
    title: 'Dashboard',
    breadcrumb: null
  }

},
{
  name: 'atender',
  component: AtencionPaciente,
  path: '/atender/:id',
  props: {
    titulo: 'Ver',
    operacion: 'lectura'
  },
  meta: {
    requiresAuth: true,
    title: 'Ver',
    breadcrumb: null
  }
},
{
  name: 'agenda',
  component: Agenda,
  path: 'agenda',
  meta: {
    requiresAuth: true,
    title: 'Agenda',
    breadcrumb: null
  }

}]

export default rutas
